import SpinnerIcon from "../icons/AikaIcons/SpinnerIcon";

export default function Spinner({
  inline = false,
  label = "",
  size = 48,
  className = "",
}: {
  size: number;
  label: string;
  inline?: boolean;
  className?: string;
}) {
  return (
    <div className={styles(inline, className)}>
      <SpinnerIcon height={size} />
      {label && <div>{label}</div>}
    </div>
  );
}

function styles(inline: boolean, className?: string) {
  return inline
    ? `c-spinner flex-row gap-2 text-info${className ? " " + className : ""}`
    : `c-spinner flex-column gap-2 text-info${
        className ? " " + className : ""
      }`;
}
